export default __webpack_public_path__ + "static/media/user-image.f30691b9.jpg";